import React from 'react';
import { useWallet } from '@solana/wallet-adapter-react';
import { useWalletModal } from '@solana/wallet-adapter-react-ui';
import { openWalletPicker } from '../utils/mobileWallet';

const ConnectButton = () => {
    const { setVisible } = useWalletModal();
    const { publicKey, connected, disconnect, select } = useWallet();
    const connectedAddress = publicKey ? publicKey.toBase58() : '';

    const handleClick = async (event) => {
        event.preventDefault();
        if (connected) {
            await disconnect();
            return;
        }
        openWalletPicker({ select, setVisible });
    };

    return (
        <button
            type='button'
            onClick={handleClick}
            className='bg-secondary flex items-center px-3 py-3 gap-2 text-black rounded-2xl min-h-[44px] shrink-0'
        >
            <img className='w-[30px]' src='../../assets/Vector.png' alt='Connect Wallet' />
            {connectedAddress ? (
                <span>{`${connectedAddress.slice(0, 4)}...${connectedAddress.slice(-4)}`}</span>
            ) : (
                <span className='max-[380px]:text-sm'>Connect Wallet</span>
            )}
        </button>
    );
};

export default ConnectButton;
